import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable.tsx";
import { db, userDataCollection } from "@/firebase";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class BalliRegulation extends Vue {
  completed = false;
  private _questions: [{ question: string; answer: number; qid: number }];
  introCompleted = false;

  constructor() {
    super();
    this._questions = this.$store.getters.balliQuestions.regulation;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balliQuestions.regulation;
  }

  hasCompleted(completed: boolean) {
    this.completed = completed;
  }

  submit() {
    var thisUser = this.$store.getters.user;
    var uid = thisUser.data.uid;

    if (this.$store.getters.balliSections[3].progress != 100) {
      updateStudentScoring();
      let timepoint = this.$store.getters.balliTimepointStr;

      // Store the responses
      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(this.$store.getters.balliTimepointStr)
        .collection("responses")
        .doc("regulation")
        .set({ Answers: this._questions })
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("balli")
            .doc(timepoint)
            .update({
              "completionStatus.regulation": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          //console.error("Error writing responses for Balli Regulation: ", error);
        });

      // Update progress in $store
      this.$store.commit("markBalliComplete", "Regulation");
      this.$store.commit("progressBalli", this._questions.length);
    }

    // Move to Grit
    this.$router.push({ name: "balliGrit" });
  }

  private introScreen() {
    return (
      <Card>
        <div slot="mainContent">
          <span class="subtitle-1">
            Tell us how you regulate your learning!
          </span>
        </div>
        <div slot="actions">
          <v-btn
            color="primary"
            onClick={() => {
              this.introCompleted = true;
            }}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  private mainContent() {
    return (
      <Card
        title="Let's talk about your regulation. Does this sound like you?"
        mod={Module.BALLI}
      >
        <v-form ref="form" slot="mainContent">
          <RadioTable
            questions={this._questions}
            onUpdate={this.hasCompleted}
            fixHeader={true}
            disabled={this.$store.getters.balliSections[3].progress == 100}
            labelType={this.$store.getters.balliRadioHeader}
          ></RadioTable>
        </v-form>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="attitude">
            Back
          </v-btn>
          <v-btn
            color="primary"
            disabled={!this.completed}
            onClick={this.submit}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.introCompleted ? this.mainContent() : this.introScreen();
  }
}

const component = BalliRegulation;
